//

import { mapGetters, mapMutations, mapActions } from "vuex";
import SCFunctionCanvasElements from "@/components/SmartContractDesigner/SCFunctionsHandler/SCFunctionCanvasElements/SCFunctionCanvasElements.vue";
import { SMART_CONTRACT_TYPES } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import { SELECTED_PLUGIN_INFORMATION_DATA } from "@/store/modules/smartContractDesigner/const/selectedPluginInformationData";

export default {
    name: "ScFunctionCanvasElements",
    components: {
        expressionHandlerWrapper: () => import("@/components/SmartContractDesigner/handlers/Control/ExpressionHandlerWrapper/ExpressionHandlerWrapper.vue"),
        ifHandler: () => import("@/components/SmartContractDesigner/handlers/Control/IfHandler/IfHandler.vue"),
        callHandler: () => import("@/components/SmartContractDesigner/handlers/Control/CallHandler/CallHandler.vue"),
        emitEventHandler: () => import("@/components/SmartContractDesigner/handlers/Control/EmitEventHandler/EmitEventHandler.vue"),
        doWhileHandler: () => import("@/components/SmartContractDesigner/handlers/Looping/DoWhileHandler/DoWhileHandler.vue"),
        forHandler: () => import("@/components/SmartContractDesigner/handlers/Looping/ForHandler/ForHandler.vue"),
        whileHandler: () => import("@/components/SmartContractDesigner/handlers/Looping/WhileHandler/WhileHandler.vue"),
        assignHandler: () => import("@/components/SmartContractDesigner/handlers/Variables/AssignHandler/AssignHandler.vue"),
        declareHandler: () => import("@/components/SmartContractDesigner/handlers/Variables/DeclareHandler/DeclareHandler.vue")
    },
    props: {
        readonly: Boolean
    },
    data() {
        return {
            selectedTab: "details",
            tabs: ["details", "params", "returns"],
            displayFabricModal: false,
            displayCodePreview: false,
            inEditOrAddFunc: null,
            showDeleteDlg: false,
            deletingIndex: null,
            selectedFunction: null,
            functionCanvasElements: null
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", [
            "selectedPluginComponent",
            "selectedPluginData",
            "inEditFunction",
            "selectedPluginUuid"
        ]),
        hasNodes() {
            return this.inEditFunction && this.inEditFunction.body.length;
        },
        getNodes() {
            return this.inEditFunction && this.inEditFunction.body
                ? this.inEditFunction.body
                    .filter(
                        node => node.nodeType !== SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN
                && node.nodeType !== SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN
                && node.nodeType !== SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR
                && node.nodeType
                    )
                    .map(elem => {
                        const elemCopy = { ...elem };
                        const data = SELECTED_PLUGIN_INFORMATION_DATA.find(elemData => (
                            elemData.id === elem.nodeType || elemData.typeId === elem.nodeType
                        ));
                        if (data) {
                            elemCopy.labelElemType = data.name;
                        }
                        return elemCopy;
                    })
                : null;
        }
    },
    watch: {
        selectedPluginData() {}
    },
    methods: {
        ...mapMutations("smartContractDesigner", []),
        ...mapActions("smartContractDesigner", []),
        actionsDlg($event) {
            if ($event.detailed === "action_save") {
            }
        },
        collapsedItem(obj) {
            const elem = this.inEditFunction.diagramData.content.find(
                elem => elem.uuid === obj.id
            );
            const self = this;
            setTimeout(() => {
                self.$emit("pluginSelected", { uuid: obj.id, id: elem.id });
            }, 0);
        }
    },
    mounted() {}
};
